module.exports = __webpack_public_path__ + "img/3.a0aac35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/3.png
// module id = rgrU
// module chunks = 1